import React from 'react';
import NavigationExact from '../components/NavigationExact';
import HeroExact from '../components/HeroExact';
import WhoWeAre from '../components/WhoWeAre';
import OurServices from '../components/OurServices';
import FAQ from '../components/FAQ';
import FooterExact from '../components/FooterExact';
import SEO from '../components/SEO';
import FundingSathiModal from '../components/FundingSathiModal';

const HomePageExact = () => {
  return (
    <>
      <SEO />
      <NavigationExact />
      
      <main className="pt-16">
        {/* Hero Section */}
        <HeroExact />
        
        {/* Who We Are Section */}
        <WhoWeAre />
        
        {/* Our Services Section */}
        <OurServices />
        
        {/* Frequently Asked Questions */}
        <FAQ />
      </main>
      
      <FooterExact />
      <FundingSathiModal />
    </>
  );
};

export default HomePageExact;
